export const OPEN_MODAL = 'OPEN_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const UPDATE_MODAL_PROP = 'UPDATE_MODAL_PROP'
export const UPDATE_OBJEKT_MODAL_PROP = 'UPDATE_OBJEKT_MODAL_PROP'



// WEBPACK FOOTER //
// ./src/store/actions/modal.js